// utils.js
export const formatToIndianRupee = (amount) => {
    if (isNaN(amount)) return amount; 
    const number = Number(amount);
    const formatted = number.toLocaleString('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    // Add space between ₹ symbol and the amount
    return formatted.replace('₹', '₹ ');
};